export default function initDateStandards(date) {
  return {
    key: date?.formal || date?.normalized?.[0]?.value,
    original: date?.original || '',
    formal: date?.formal || '',
    primaryText: date?.normalized?.[0]?.value || '',
  }
}
